import React from 'react';
import styled from 'styled-components';
import SpanPrice from '../common/price/SpanPrice'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import * as F from '../../lib/util/CommonFunctions'
import { Link } from 'react-router-dom';

const BrBrandProdItemBlock = styled.li`
    float: left;
    width: 182px;
    padding-left: 30px;
    ${isMobileOnly && "padding-left: 0px"}; 
    ${isMobileOnly && "padding-right: 20px"}; 
    ${isMobileOnly && "width: 172px"}; 
`;

const BrBrandProdItemPBlock = styled.p`
    margin-bottom: 20px;
    overflow: hidden;
    cursor: pointer;
    line-height : 152px;
`;

const BrBrandProdItemImg = styled.img`
    border-radius: 4px;
    min-width: 152px;
    min-height: 100%;
    object-position: center;
    cursor: pointer;
    max-width : 152px;
    max-height : 152px;
    vertical-align : middle;
    object-fit: cover;
`

const BrBrandProdItemTitleSpanBlock = styled.span`
    max-height: 38px;
    line-height: 1.4;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

/* const BrBrandProdItemBrandSpanBlock = styled.span`
    display: ${props => props.display};
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
`; */

const BrBrandProdItem = ({ img, prodname, sale_price, prdct_price, onClick, prdct_id}) => {

    // console.log("brandname : " + brandname);
    return (
        <BrBrandProdItemBlock >
            <Link to={"/prod?prodid="+prdct_id}>
            <BrBrandProdItemPBlock>
                <BrBrandProdItemImg src={img} />
            </BrBrandProdItemPBlock>

            <BrBrandProdItemTitleSpanBlock>
                {prodname}
            </BrBrandProdItemTitleSpanBlock>

            {/*<SpanPrice value={sale_price} isSale={false} />*/}
            {/*{*/}
            {/*    sale_price === prdct_price ? '' :*/}
            {/*        <SpanPrice value={prdct_price} isSale={true} />*/}
            {/*}*/}

          {F.showAmount({
            prefix: "견적시작가 ",
            pfFontSize: "12px",
            pfWeight: "400",
            fontSize: "18px",
            amount: sale_price,
            weight: "500",
            unit:""
          })}
          </Link>
        </BrBrandProdItemBlock>
    );
};

export default BrBrandProdItem;
